import type { ComponentProps } from "react";

import { cn } from "@facade/lib/utils";

type CountBadgeProps = ComponentProps<"span"> & {
  count: number;
};

export function CountBadge({ count, className, ...props }: CountBadgeProps) {
  if (count <= 0) return null;

  return (
    <span
      className={cn(
        "inline-flex min-w-4 items-center justify-center rounded-full bg-destructive px-1 text-[0.625rem] font-semibold leading-4 text-white",
        className,
      )}
      {...props}
    >
      {count > 99 ? "99+" : count}
    </span>
  );
}
